(function () {
  const CONTAINER_ID = 'somml-container';
  const ROOT_ID = 'somml-root';
  const WIDGET_ID = 'somml-widget';
  const LAUNCHER_ID = 'somml-launcher';
  const API_URL = 'https://bottleofitaly-chatbot-0a5bf6e64b1f.herokuapp.com/chat';


  function detectLang() {
    const p = location.pathname;
    if (p.startsWith('/en')) return 'en';
    if (p.startsWith('/fr')) return 'fr';
    if (p.startsWith('/de')) return 'de';
    return 'it';
  }
  function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  let observerStarted = false;

  function initSomml() {
    const mount = document.getElementById(CONTAINER_ID);
    if (!mount) return false;
    if (mount.querySelector(`#${ROOT_ID}`)) return true;

    const uiLang = detectLang();

    function bubbleKey(pid) {
      return `somml:bubblesUsed:${uiLang}:${pid}`;
    }

    function getUsedIntents(pid) {
      try {
        const raw = sessionStorage.getItem(bubbleKey(pid));
        return raw ? JSON.parse(raw) : {};
      } catch {
        return {};
      }
    }

    function markIntentUsed(pid, intent) {
      const used = getUsedIntents(pid);
      used[intent] = true;
      sessionStorage.setItem(bubbleKey(pid), JSON.stringify(used));
    }

    function getProductId() {
      const fromData = mount.getAttribute('data-product-id') || mount.dataset?.productId;
      if (fromData && String(fromData).trim()) return Number(fromData);
      if (window.currentProductId) return Number(window.currentProductId);
      const metaPid = window.ShopifyAnalytics?.meta?.product?.id;
      if (metaPid) return Number(metaPid);
      const shopifyPid = window.Shopify?.product?.id;
      if (shopifyPid) return Number(shopifyPid);
      return null;
    }

    // IDs utente/sessione
    let userId = document.cookie.match(/chatUserId=([^;]+)/);
    if (userId) userId = userId[1];
    else {
      userId = uuidv4();
      document.cookie = `chatUserId=${userId};path=/;max-age=${365 * 24 * 60 * 60}`;
    }
    const sessionId = uuidv4();

    // UI
    const root = document.createElement('div');
    root.id = ROOT_ID;

    const wrapper = document.createElement('div');
    wrapper.style.margin = '20px 0';
    wrapper.style.textAlign = 'center';

    const launchLabels = {
      it: 'Chiedi al Sommelier AI',
      en: 'Ask to Sommelier AI',
      fr: 'Demandez au Sommelier IA',
      de: 'Fragen Sie den Sommelier AI'
    };

    const inputPlaceholders = {
      it: 'Scrivi un messaggio…',
      en: 'Type a message…',
      fr: 'Écrivez un message…',
      de: 'Nachricht eingeben…'
    };

    const launcher = document.createElement('button');
    launcher.id = LAUNCHER_ID;
    launcher.type = 'button';
    launcher.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 509.727 509.727"
        preserveAspectRatio="xMidYMid meet"
        style="vertical-align:middle;margin-right:8px;width:24px;height:24px;fill:currentColor;transform:translateY(-4px);">
        <g>
          <path d="M232.406 179.611h67.469v330.116h-67.469zM101.203 162.744C45.4 162.744 0 208.144 0 263.947v245.78h67.469V406.114h67.469v103.614h67.469v-245.78c-.001-55.804-45.4-101.204-101.204-101.204zm33.735 175.901H67.469v-74.698c0-18.601 15.133-33.734 33.734-33.734s33.734 15.133 33.734 33.734v74.698zM429.568 80.159 385.727 0l-43.84 80.159L261.727 124l80.16 43.841L385.727 248l43.841-80.159L509.727 124z"/>
        </g>
      </svg>
      <span style="vertical-align:middle;">${launchLabels[uiLang]}</span>
    `;
    Object.assign(launcher.style, {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '10px 16px',
      backgroundColor: '#86023f',
      color: '#fff',
      borderRadius: '8px',
      textDecoration: 'none',
      fontWeight: '600',
      fontSize: '16px',
      cursor: 'pointer',
      border: '0',
      transition: 'background-color 0.2s ease'
    });
    launcher.addEventListener('mouseenter', () => launcher.style.backgroundColor = '#a93863');
    launcher.addEventListener('mouseleave', () => launcher.style.backgroundColor = '#86023f');

    wrapper.appendChild(launcher);

    // bubbles sotto bottone
    const launcherBubbles = document.createElement('div');
    Object.assign(launcherBubbles.style, {
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
      gap: '8px',
      marginTop: '10px'
    });
    wrapper.appendChild(launcherBubbles);

    const widget = document.createElement('div');
    widget.id = WIDGET_ID;
    widget.classList.remove('open');
    Object.assign(widget.style, {
      overflow: 'hidden',
      maxHeight: '0',
      transition: 'max-height 0.3s ease',
      borderLeft: '1px solid #ddd',
      borderRight: '1px solid #ddd',
      borderBottom: '1px solid #ddd',
      background: '#fff',
      display: 'flex',
      flexDirection: 'column',
      height: '500px'
    });

    const header = document.createElement('div');
    Object.assign(header.style, {
      padding: '12px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderTopLeftRadius: '8px',
      borderTopRightRadius: '8px',
      background: '#f9f9f9',
      borderBottom: '1px solid #ddd'
    });

    const title = document.createElement('span');
    title.textContent = 'Bottle of Italy Sommelier AI';

    const btnClose = document.createElement('button');
    btnClose.type = 'button';
    btnClose.textContent = '×';
    Object.assign(btnClose.style, {
      background: 'none',
      border: 'none',
      fontSize: '24px',
      cursor: 'pointer',
      lineHeight: '1'
    });

    header.appendChild(title);
    header.appendChild(btnClose);
    widget.appendChild(header);

    const chat = document.createElement('div');
    Object.assign(chat.style, {
      padding: '12px',
      overflowY: 'auto',
      flex: '1',
      display: 'flex',
      flexDirection: 'column'
    });
    widget.appendChild(chat);

    const inputWrap = document.createElement('div');
    Object.assign(inputWrap.style, {
      display: 'flex',
      borderTop: '1px solid #ddd',
      alignItems: 'center',
      padding: '8px'
    });

    const input = document.createElement('input');
    Object.assign(input.style, {
      flex: '1',
      border: '1px solid #ccc',
      borderRadius: '4px',
      padding: '8px 12px',
      fontSize: '16px',
      marginRight: '8px',
      background: '#fafafa',
      WebkitTextSizeAdjust: '100%'
    });
    input.placeholder = inputPlaceholders[uiLang];

    const btnSend = document.createElement('button');
    btnSend.type = 'button';
    btnSend.innerHTML = '➤';
    Object.assign(btnSend.style, {
      width: '36px',
      height: '36px',
      border: 'none',
      background: 'none',
      fontSize: '20px',
      cursor: 'pointer',
      color: '#007bff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    });

    inputWrap.appendChild(input);
    inputWrap.appendChild(btnSend);
    widget.appendChild(inputWrap);

    wrapper.appendChild(widget);
    root.appendChild(wrapper);
    mount.appendChild(root);

    // state
    const conversation = [];
    let initialized = false;

    // bubbles in chat
    let chatBubblesEl = null;
    function clearChatBubbles() {
      if (chatBubblesEl) {
        chatBubblesEl.remove();
        chatBubblesEl = null;
      }
    }

    function safeText(t) {
      if (t === null || t === undefined) return '';
      return String(t);
    }

    function addMsg(who, text) {
      const msg = document.createElement('div');
      const t = safeText(text);
      const html = t
        .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
        .replace(/\n/g,'<br>')
        .replace(/(https?:\/\/[^\s<]+)/g,'<a href="$1" target="_blank">$1</a>');

      msg.innerHTML = html;
      Object.assign(msg.style, {
        padding: '8px',
        margin: '6px 0',
        borderRadius: '6px',
        maxWidth: '80%',
        alignSelf: who === 'user' ? 'flex-end' : 'flex-start',
        background: who === 'user' ? '#e8f0fe' : '#f1f1f1',
        fontSize: '14px',
        textAlign: 'left'
      });
      chat.appendChild(msg);
      chat.scrollTop = chat.scrollHeight;
    }

    // typing indicator (single instance)
    let dotInterval = null;
    function showTyping() {
      // evita doppi indicatori
      if (document.getElementById('typing-indicator')) return;

      const ind = document.createElement('div');
      ind.id = 'typing-indicator';
      Object.assign(ind.style, {
        padding: '8px',
        margin: '6px 0',
        borderRadius: '6px',
        maxWidth: '80%',
        alignSelf: 'flex-start',
        background: '#f1f1f1',
        fontStyle: 'italic',
        color: '#666',
        fontSize: '14px'
      });
      chat.appendChild(ind);
      chat.scrollTop = chat.scrollHeight;

      let dots = 0;
      if (dotInterval) clearInterval(dotInterval);
      dotInterval = setInterval(() => {
        dots = (dots + 1) % 4;
        ind.textContent = 'AI is typing' + '.'.repeat(dots);
      }, 400);
    }
    function hideTyping() {
      if (dotInterval) clearInterval(dotInterval);
      dotInterval = null;
      const ind = document.getElementById('typing-indicator');
      if (ind) ind.remove();
    }

    const DEFAULT_BUBBLES = {
      it: [
        { label: "🍽 Con cosa abbinarlo?", intent: "pairing" },
        { label: "🍷 Che tipo di prodotto è?", intent: "product_info" },
        { label: "🎁 È adatto come regalo?", intent: "gift" },
        { label: "🔁 Un’alternativa simile?", intent: "alternative" }
      ],
      en: [
        { label: "🍽 What should I pair it with?", intent: "pairing" },
        { label: "🍷 What kind of product is it?", intent: "product_info" },
        { label: "🎁 Is it good as a gift?", intent: "gift" },
        { label: "🔁 A similar alternative?", intent: "alternative" }
      ],
      fr: [
        { label: "🍽 Avec quels plats l’associer ?", intent: "pairing" },
        { label: "🍷 Quel type de produit est-ce ?", intent: "product_info" },
        { label: "🎁 Convient-il comme cadeau ?", intent: "gift" },
        { label: "🔁 Une alternative similaire ?", intent: "alternative" }
      ],
      de: [
        { label: "🍽 Wozu passt es?", intent: "pairing" },
        { label: "🍷 Was für ein Produkt ist das?", intent: "product_info" },
        { label: "🎁 Als Geschenk geeignet?", intent: "gift" },
        { label: "🔁 Eine ähnliche Alternative?", intent: "alternative" }
      ]
    };

    
    // ---------------- Dynamic bubbles (client-side) ----------------
    const DYNAMIC_LABELS = {
      aroma_profile: { it:"👃 Profilo aromatico?", en:"👃 Aroma profile?", fr:"👃 Profil aromatique ?", de:"👃 Aromaprofil?" },
      serving_temperature: { it:"🌡️ Temperatura di servizio?", en:"🌡️ Serving temperature?", fr:"🌡️ Température de service ?", de:"🌡️ Serviertemperatur?" },
      decanting: { it:"🍷 Va decantato?", en:"🍷 Should I decant it?", fr:"🍷 Faut-il le décanter ?", de:"🍷 Dekantieren?" },
      aging_potential: { it:"⏳ Quanto può invecchiare?", en:"⏳ How long can it age?", fr:"⏳ Potentiel de garde ?", de:"⏳ Reifepotenzial?" },
      dryness_sweetness: { it:"⚖️ È più secco o più morbido?", en:"⚖️ Is it drier or sweeter?", fr:"⚖️ Plutôt sec ou plus doux ?", de:"⚖️ Eher trocken oder weicher?" },
      aperitivo_or_meal: { it:"🥂 Aperitivo o a tavola?", en:"🥂 Aperitif or with food?", fr:"🥂 Apéritif ou à table ?", de:"🥂 Aperitif oder zum Essen?" },
      quick_aperitivo_pairings: { it:"⚡🍽️ Aperitivo: 3 abbinamenti rapidi", en:"⚡🍽️ Aperitif: 3 quick pairings", fr:"⚡🍽️ Apéritif : 3 accords rapides", de:"⚡🍽️ Aperitif: 3 schnelle Pairings" },
      sweet_or_savory: { it:"🍰 Meglio con salato o dolce?", en:"🍰 Better with savory or sweet?", fr:"🍰 Plutôt salé ou sucré ?", de:"🍰 Besser zu herzhaft oder süß?" },
      best_occasion: { it:"🎉 Occasione ideale?", en:"🎉 Best occasion?", fr:"🎉 Meilleure occasion ?", de:"🎉 Beste Gelegenheit?" },

      beer_style_taste: { it:"🍺 Che stile è e che gusto ha?", en:"🍺 What style is it and how does it taste?", fr:"🍺 Quel style et quel goût ?", de:"🍺 Welcher Stil und Geschmack?" },
      bitterness_level: { it:"🌿 È amara o più morbida?", en:"🌿 Is it bitter or smoother?", fr:"🌿 Amère ou plus douce ?", de:"🌿 Bitter oder milder?" },

      oil_intensity: { it:"🫒 Delicato o intenso?", en:"🫒 Delicate or intense?", fr:"🫒 Doux ou intense ?", de:"🫒 Mild oder intensiv?" },
      oil_raw_or_cook: { it:"🍳 A crudo o in cottura?", en:"🍳 Raw or for cooking?", fr:"🍳 À cru ou en cuisson ?", de:"🍳 Roh oder zum Kochen?" },
      oil_best_dishes: { it:"🍝 Su quali piatti rende meglio?", en:"🍝 Best dishes to use it with?", fr:"🍝 Sur quels plats est-il idéal ?", de:"🍝 Zu welchen Gerichten passt es am besten?" },
      oil_storage: { it:"🫙 Come conservarlo?", en:"🫙 How to store it?", fr:"🫙 Comment le conserver ?", de:"🫙 Wie lagert man es?" },

      gadget_how_to_use: { it:"🛠️ Come si usa?", en:"🛠️ How do I use it?", fr:"🛠️ Comment l’utiliser ?", de:"🛠️ Wie benutzt man es?" },
      gadget_compatibility: { it:"📏 Compatibilità / dettagli", en:"📏 Compatibility / details", fr:"📏 Compatibilité / détails", de:"📏 Kompatibilität / Details" },
      gadget_maintenance: { it:"🧼 Pulizia / manutenzione", en:"🧼 Cleaning / maintenance", fr:"🧼 Nettoyage / entretien", de:"🧼 Reinigung / Pflege" },

      spirits_how_to_drink: { it:"🥃 Liscio, ghiaccio o cocktail?", en:"🥃 Neat, on ice, or cocktails?", fr:"🥃 Pur, sur glace ou en cocktail ?", de:"🥃 Pur, auf Eis oder Cocktail?" },
      gin_botanicals: { it:"🌿 Botaniche principali?", en:"🌿 Main botanicals?", fr:"🌿 Botaniques principales ?", de:"🌿 Haupt-Botanicals?" },
      gin_tonic: { it:"🥤 Tonica consigliata?", en:"🥤 Recommended tonic?", fr:"🥤 Tonic recommandé ?", de:"🥤 Empfohlene Tonic?" },
      gin_garnish: { it:"🍋 Guarnizione ideale?", en:"🍋 Best garnish?", fr:"🍋 Garniture idéale ?", de:"🍋 Beste Garnitur?" },
      rum_notes: { it:"🍯 Note (vaniglia/caramello/spezie)?", en:"🍯 Notes (vanilla/caramel/spice)?", fr:"🍯 Notes (vanille/caramel/épices) ?", de:"🍯 Noten (Vanille/Karamell/Gewürze)?" },
      rum_neat_or_cocktail: { it:"🥃 Meglio liscio o in cocktail?", en:"🥃 Better neat or in cocktails?", fr:"🥃 Plutôt pur ou en cocktail ?", de:"🥃 Besser pur oder im Cocktail?" },
      vodka_profile: { it:"❄️ Neutra o aromatica?", en:"❄️ Neutral or flavored?", fr:"❄️ Neutre ou aromatisée ?", de:"❄️ Neutral oder aromatisiert?" },
      vodka_cocktails: { it:"🍸 Cocktail consigliati?", en:"🍸 Recommended cocktails?", fr:"🍸 Cocktails conseillés ?", de:"🍸 Empfohlene Cocktails?" },
      brandy_notes: { it:"🪵 Note (legno/spezie/frutta secca)?", en:"🪵 Notes (wood/spice/dried fruit)?", fr:"🪵 Notes (bois/épices/fruits secs) ?", de:"🪵 Noten (Holz/Gewürze/Trockenfrüchte)?" },
      brandy_serving: { it:"🥃 Come servirlo?", en:"🥃 How should I serve it?", fr:"🥃 Comment le servir ?", de:"🥃 Wie servieren?" },
      amaro_balance: { it:"🌿 Quanto è amaro/dolce?", en:"🌿 How bitter/sweet is it?", fr:"🌿 Plutôt amer ou doux ?", de:"🌿 Wie bitter/süß?" },
      amaro_serving: { it:"🧊 Freddo o ambiente?", en:"🧊 Chilled or room temp?", fr:"🧊 Frais ou à température ambiante ?", de:"🧊 Gekühlt oder Zimmertemperatur?" },
      grappa_young_or_aged: { it:"🪵 Giovane o barriccata?", en:"🪵 Young or aged in wood?", fr:"🪵 Jeune ou vieillie en bois ?", de:"🪵 Jung oder im Holz gereift?" },

      product_info: { it:"🍷 Che tipo di prodotto è?", en:"🍷 What kind of product is it?", fr:"🍷 Quel type de produit est-ce ?", de:"🍷 Was für ein Produkt ist das?" },
      pairing: { it:"🍽 Con cosa abbinarlo?", en:"🍽 What should I pair it with?", fr:"🍽 Avec quels plats l’associer ?", de:"🍽 Wozu passt es?" },
      gift: { it:"🎁 È adatto come regalo?", en:"🎁 Is it good as a gift?", fr:"🎁 Convient-il comme cadeau ?", de:"🎁 Als Geschenk geeignet?" },
      alternative: { it:"🔁 Un’alternativa simile?", en:"🔁 A similar alternative?", fr:"🔁 Une alternative similaire ?", de:"🔁 Eine ähnliche Alternative?" }
    };


    const PRODUCT_TYPE_MAP = {
      "vino rosso": "VINO_ROSSO",
      "vino bianco": "VINO_BIANCO",
      "vino rosato": "VINO_ROSATO",
      "bollicine": "BOLLICINE",
      "spirits": "SPIRITS",
      "olio": "OLIO",
      "gadget": "GADGET",
      "birra": "BIRRA",
      "altro": "ALTRO"
    };

    function normalizeText(s) {
      return String(s || "").trim().toLowerCase();
    }

    function normalizeTags(tags) {
      if (!tags) return [];
      if (Array.isArray(tags)) return tags.map(t => String(t).trim()).filter(Boolean);
      if (typeof tags === "string") return tags.split(",").map(t => t.trim()).filter(Boolean);
      return [];
    }

    function detectSpiritsSubtype(tags = []) {
      const set = new Set(normalizeTags(tags).map(t => t.toLowerCase()));
      const order = ["cognac","brandy","whisky","whiskey","gin","rum","vodka","amaro","grappa"];
      for (const k of order) if (set.has(k)) return k === "whiskey" ? "whisky" : k;
      return "generic";
    }

    function makeBubble(lang, intent) {
      const l = DYNAMIC_LABELS[intent];
      if (!l) return null;
      const label = l[lang] || l.en;
      if (!label) return null;
      return { label, intent };
    }

    function uniqBubbles(arr) {
      const seen = new Set();
      return (arr || []).filter(b => {
        const key = b && b.intent;
        if (!key || seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    }

    function mergeLauncherBubbles(defaultSet, dynamicSet) {
      const base = Array.isArray(defaultSet) ? defaultSet : [];
      const dyn  = Array.isArray(dynamicSet) ? dynamicSet : [];
      const intents = new Set(base.map(b => b && b.intent).filter(Boolean));
      const extra = dyn.filter(b => b && b.intent && !intents.has(b.intent));
      return base.concat(extra);
    }

    function getProductContext() {
      const productId = getProductId();

      const productType =
        window.currentProductType ||
        window.BOI_PRODUCT?.product_type ||
        window.BOI_PRODUCT?.productType ||
        window.ShopifyAnalytics?.meta?.product?.type ||
        window.meta?.product?.type ||
        mount.getAttribute("data-product-type") ||
        mount.dataset?.productType ||
        null;

      const tags =
        window.currentProductTags ||
        window.BOI_PRODUCT?.tags ||
        window.ShopifyAnalytics?.meta?.product?.tags ||
        mount.getAttribute("data-product-tags") ||
        mount.dataset?.productTags ||
        null;

      return { productId, productType, tags: normalizeTags(tags) };
    }

    function computeDynamicBubbles(lang) {
      const safeLang = ["it","en","fr","de"].includes(lang) ? lang : "en";
      const ctx = getProductContext();
      const ptKey = PRODUCT_TYPE_MAP[normalizeText(ctx.productType)] || null;

      // Se non abbiamo product_type, non possiamo “personalizzare” davvero.
      if (!ptKey) return null;

      const tags = ctx.tags || [];
      let intents = [];

      switch (ptKey) {
        case "VINO_ROSSO":
          intents = ["aroma_profile","serving_temperature","decanting","pairing","aging_potential","gift","alternative"];
          break;
        case "VINO_BIANCO":
          intents = ["aroma_profile","serving_temperature","aperitivo_or_meal","pairing","dryness_sweetness","gift","alternative"];
          break;
        case "VINO_ROSATO":
          intents = ["aroma_profile","serving_temperature","aperitivo_or_meal","pairing","best_occasion","gift","alternative"];
          break;
        case "BOLLICINE":
          intents = ["dryness_sweetness","serving_temperature","quick_aperitivo_pairings","sweet_or_savory","best_occasion","gift","alternative"];
          break;
        case "BIRRA":
          intents = ["beer_style_taste","serving_temperature","bitterness_level","pairing","best_occasion","gift"];
          break;
        case "OLIO":
          intents = ["oil_intensity","oil_raw_or_cook","oil_best_dishes","oil_storage","gift","alternative"];
          break;
        case "GADGET":
          intents = ["gadget_how_to_use","gadget_compatibility","gadget_maintenance","gift"];
          break;
        case "SPIRITS": {
          const sub = detectSpiritsSubtype(tags);
          if (sub === "gin") intents = ["gin_botanicals","gin_tonic","gin_garnish","spirits_how_to_drink","gift","alternative"];
          else if (sub === "rum") intents = ["rum_notes","rum_neat_or_cocktail","spirits_how_to_drink","gift","alternative"];
          else if (sub === "vodka") intents = ["vodka_profile","vodka_cocktails","spirits_how_to_drink","gift","alternative"];
          else if (sub === "cognac" || sub === "brandy") intents = ["brandy_notes","brandy_serving","spirits_how_to_drink","gift","alternative"];
          else if (sub === "amaro") intents = ["amaro_balance","amaro_serving","spirits_how_to_drink","gift","alternative"];
          else if (sub === "grappa") intents = ["grappa_young_or_aged","brandy_serving","spirits_how_to_drink","gift","alternative"];
          else intents = ["spirits_how_to_drink","aroma_profile","best_occasion","gift","alternative"];
          break;
        }
        default:
          intents = ["product_info","pairing","best_occasion","gift","alternative"];
      }

      const bubbles = uniqBubbles(intents.map(i => makeBubble(safeLang, i)).filter(Boolean));
      return bubbles.length ? bubbles : null;
    }

function openChatIfNeeded() {
      if (!widget.classList.contains('open')) {
        widget.style.maxHeight = '500px';
        widget.classList.add('open');
      }
      if (!initialized) {
        const intros = {
          it: 'Ciao! Sono il tuo Sommelier AI. Puoi chiedermi maggiori informazioni su questo prodotto o con che piatti abbinarlo o ricette perfette.',
          en: 'Hi! I am your AI Sommelier. You can ask me more information about this product or what dishes to pair it with or perfect recipes.',
          fr: 'Bonjour ! Je suis votre sommelier AI. Vous pouvez me demander plus d informations sur ce produit, sur les plats qui l accompagnent ou sur les recettes parfaites.',
          de: 'Hallo! Ich bin Ihr AI-Sommelier. Sie können mich mehr über dieses Produkt fragen oder welche Gerichte dazu passen.'
        };
        addMsg('assistant', intros[uiLang] || intros.en);
        initialized = true;
        // (Re)calcola le bubble dinamiche quando si apre la chat, così se il tema le setta dopo il load le prendiamo comunque.
        const dyn = computeDynamicBubbles(uiLang);
        if (dyn) chatBubbleSet = dyn;
        launcherBubbleSet = mergeLauncherBubbles(launcherDefaultSet, chatBubbleSet);
        renderLauncherBubbles(launcherBubbleSet);
        renderChatBubbles(chatBubbleSet);
      }
    }

    function renderLauncherBubbles(bubbles) {
      const pid = getProductId();
      const used = pid ? getUsedIntents(pid) : {};
      launcherBubbles.innerHTML = '';
      (bubbles || []).filter(b => !used[b.intent]).forEach(b => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.textContent = b.label;
        Object.assign(btn.style, {
          background: '#f1f1f1',
          borderRadius: '999px',
          border: '0',
          padding: '6px 12px',
          fontSize: '13px',
          cursor: 'pointer'
        });
        btn.addEventListener('click', () => {
          const pid = getProductId();
          if (pid) markIntentUsed(pid, b.intent);
          renderLauncherBubbles(launcherBubbleSet);
          clearChatBubbles();
          openChatIfNeeded();
          sendIntent(b.intent, b.label);
        });
        launcherBubbles.appendChild(btn);
      });
    }

    function renderChatBubbles(bubbles) {
      const pid = getProductId();
      const used = pid ? getUsedIntents(pid) : {};
      if (!Array.isArray(bubbles) || bubbles.length === 0) return;
      clearChatBubbles();

      chatBubblesEl = document.createElement('div');
      Object.assign(chatBubblesEl.style, {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '8px',
        margin: '10px 0 0 0'
      });

      (bubbles || []).filter(b => !used[b.intent]).forEach(b => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.textContent = b.label;
        Object.assign(btn.style, {
          background: '#f1f1f1',
          borderRadius: '999px',
          border: '0',
          padding: '6px 12px',
          fontSize: '13px',
          cursor: 'pointer'
        });
        btn.addEventListener('click', () => {
          const pid = getProductId();
          if (pid) markIntentUsed(pid, b.intent);
          renderLauncherBubbles(launcherBubbleSet);
          clearChatBubbles();
          openChatIfNeeded();
          sendIntent(b.intent, b.label);
        });
        chatBubblesEl.appendChild(btn);
      });

      chat.appendChild(chatBubblesEl);
      chat.scrollTop = chat.scrollHeight;
    }

    // bubbles iniziali sotto bottone
    const launcherDefaultSet = DEFAULT_BUBBLES[uiLang] || DEFAULT_BUBBLES.en;
    // Bubble “pertinenti” in chat (calcolate localmente). Se non abbiamo product_type/tags, usiamo le default.
    let chatBubbleSet = computeDynamicBubbles(uiLang) || launcherDefaultSet;
    // Launcher = 4 default + extra dinamiche (senza duplicati)
    let launcherBubbleSet = mergeLauncherBubbles(launcherDefaultSet, chatBubbleSet);

    renderLauncherBubbles(launcherBubbleSet);

    async function postChat(payload) {
      // 1) fetch (solo errori di rete qui)
      let res;
      try {
        res = await fetch(API_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
      } catch (err) {
        // vero errore di rete / CORS / DNS
        console.error('Fetch failed:', err);
        throw new Error('NETWORK');
      }

      // 2) parse JSON (può fallire anche con 200 se risposta non-JSON)
      let data;
      try {
        data = await res.json();
      } catch (err) {
        console.error('JSON parse failed:', err, 'status=', res.status);
        throw new Error('BAD_JSON');
      }

      // 3) res.ok false -> server error (ma abbiamo json)
      if (!res.ok) {
        const msg = data?.reply || 'Server error';
        const e = new Error('SERVER');
        e.serverReply = msg;
        e.data = data;
        throw e;
      }

      return data || {};
    }

    async function sendIntent(intent, labelForUserChat) {
      clearChatBubbles();
      openChatIfNeeded();

      const pid = getProductId();
      if (!pid) {
        addMsg('assistant', {
          it: "Mi dispiace, non riesco a identificare il prodotto in questa pagina. Apri una pagina prodotto e riprova.",
          en: "Sorry, I can’t identify the product on this page. Please open a product page and try again.",
          fr: "Désolé, je ne peux pas identifier le produit sur cette page. Ouvrez une page produit et réessayez.",
          de: "Entschuldigung, ich kann das Produkt auf dieser Seite nicht erkennen. Bitte öffnen Sie eine Produktseite und versuchen Sie es erneut."
        }[uiLang]);
        return;
      }

      markIntentUsed(pid, intent);

      // ✅ mostra sempre la bubble come messaggio user (coerenza UX)
      if (labelForUserChat) {
        addMsg('user', labelForUserChat);
        // IMPORTANT: la lasciamo fuori da conversation per non “sporcare” la memoria
      }

      showTyping();
      try {
        const data = await postChat({
          message: labelForUserChat || '__BUBBLE__',
          intent,
          source: 'bubble',
          productId: pid,
          conversationHistory: conversation,
          userId,
          sessionId,
          language: uiLang
        });

        hideTyping();

        const reply = (data && typeof data.reply === 'string' && data.reply.trim())
          ? data.reply
          : (uiLang === 'it' ? "Mi dispiace, non ho una risposta disponibile al momento. Riprova." : "Sorry, I don’t have a response right now. Please try again.");

        addMsg('assistant', reply);
        conversation.push({ role: 'assistant', content: reply });
        // Aggiorna bubble (client-side): launcher = default + extra dinamiche, chat = dinamiche
        chatBubbleSet = computeDynamicBubbles(uiLang) || chatBubbleSet;
        launcherBubbleSet = mergeLauncherBubbles(launcherDefaultSet, chatBubbleSet);
        renderLauncherBubbles(launcherBubbleSet);
        renderChatBubbles(chatBubbleSet);
      } catch (err) {
        hideTyping();

        if (err.message === 'NETWORK') {
          addMsg('assistant', 'Oops, network error.');
        } else if (err.message === 'BAD_JSON') {
          addMsg('assistant', 'Oops, server response error.');
        } else if (err.message === 'SERVER') {
          addMsg('assistant', safeText(err.serverReply) || 'Oops, server error.');
        } else {
          console.error('Unexpected error:', err);
          addMsg('assistant', 'Oops, unexpected error.');
        }
      }
    }

    async function sendMsg() {
      const txt = input.value.trim();
      if (!txt) return;

      clearChatBubbles();
      openChatIfNeeded();

      const pid = getProductId();
      if (!pid) {
        addMsg('assistant', {
          it: "Mi dispiace, non riesco a identificare il prodotto in questa pagina. Apri una pagina prodotto e riprova.",
          en: "Sorry, I can’t identify the product on this page. Please open a product page and try again.",
          fr: "Désolé, je ne peux pas identifier le produit sur cette page. Ouvrez une page produit et réessayez.",
          de: "Entschuldigung, ich kann das Produkt auf dieser Seite nicht erkennen. Bitte öffnen Sie eine Produktseite und versuchen Sie es erneut."
        }[uiLang]);
        return;
      }

      addMsg('user', txt);
      conversation.push({ role: 'user', content: txt });
      input.value = '';

      showTyping();
      try {
        const data = await postChat({
          message: txt,
          source: 'user',
          productId: pid,
          conversationHistory: conversation,
          userId,
          sessionId,
          language: uiLang
        });

        hideTyping();

        const reply = (data && typeof data.reply === 'string' && data.reply.trim())
          ? data.reply
          : (uiLang === 'it' ? "Mi dispiace, non ho una risposta disponibile al momento. Riprova." : "Sorry, I don’t have a response right now. Please try again.");

        addMsg('assistant', reply);
        conversation.push({ role: 'assistant', content: reply });
        // Aggiorna bubble (client-side): launcher = default + extra dinamiche, chat = dinamiche
        chatBubbleSet = computeDynamicBubbles(uiLang) || chatBubbleSet;
        launcherBubbleSet = mergeLauncherBubbles(launcherDefaultSet, chatBubbleSet);
        renderLauncherBubbles(launcherBubbleSet);
        renderChatBubbles(chatBubbleSet);
      } catch (err) {
        hideTyping();

        if (err.message === 'NETWORK') {
          addMsg('assistant', 'Oops, network error.');
        } else if (err.message === 'BAD_JSON') {
          addMsg('assistant', 'Oops, server response error.');
        } else if (err.message === 'SERVER') {
          addMsg('assistant', safeText(err.serverReply) || 'Oops, server error.');
        } else {
          console.error('Unexpected error:', err);
          addMsg('assistant', 'Oops, unexpected error.');
        }
      }
    }

    btnSend.addEventListener('click', sendMsg);
    input.addEventListener('keydown', e => {
      if (e.key === 'Enter') {
        e.preventDefault();
        sendMsg();
      }
    });

    launcher.addEventListener('click', () => {
      openChatIfNeeded(); // solo apertura
    });

    btnClose.addEventListener('click', () => {
      widget.classList.remove('open');
      widget.style.maxHeight = '0';
      clearChatBubbles();
    });

    return true;
  }

  function bootstrap() {
    initSomml();
    document.addEventListener('shopify:section:load', initSomml);

    if (!observerStarted) {
      observerStarted = true;
      const obs = new MutationObserver(() => initSomml());
      obs.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
